import { isRetailer } from "@faire/help-center-utils/serialized-data/getRetailer";
import brandPortalAccountRoute from "@faire/web-api--source/routes/brand-portal/account";
import retailerSettingsProfile from "@faire/web-api--source/routes/retailer/settings/profile";

export const useEditSettingsLink = () => {
  const editSettingsLink = isRetailer()
    ? retailerSettingsProfile()
    : brandPortalAccountRoute({ tab: "my-account" });
  return editSettingsLink;
};
